module.exports = __webpack_public_path__ + "img/matrix_item.3789a275.png";